import { createContext } from 'react'

export type DataAccessMode = 'authenticated' | 'public'

export interface DataAccessContextValue {
  mode: DataAccessMode
}

const defaultDataAccessContext: DataAccessContextValue = {
  mode: 'authenticated',
}

export const DataAccessContext = createContext<DataAccessContextValue>(defaultDataAccessContext)
